var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.15 0.14 10.75 6.13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.521.511l-.315.292L.521 5.171l.63.724 4.37-4.076 4.37 4.077.63-.725L5.836.803z"
  })));
}

export default __webpack_public_path__ + "8f4144e245791cb2677794eb03322ce9.svg";
export { SvgChevronDown as ReactComponent };